import React, { useState } from "react";
import { Input } from "../../components/input";
import { useHistory } from "react-router-dom";
import { api } from "../../services/axios";

export const CreateOrganization = () => {
  const history = useHistory();
  let [state, setState] = useState({
    id: "",
    account_name: "",
    salesforce_id: "",
    full_name: "",
    default_name: "",
    category: "",
    menu_name: "",
    id_Errors: "",
    account_name_Errors: "",
    salesforce_id_Errors: "",
    full_name_Errors: "",
    default_name_Errors: "",
    category_Errors: "",
    menu_name_Errors: "",
  });

  const handleChange = (field: any, e: any) => {
    setState({
      ...state,
      [field]: e.target.value,
      [field + "Errors"]: "",
    });
  };

  const submit = async () => {
    try {
      let {
        id,
        account_name,
        salesforce_id,
        full_name,
        default_name,
        category,
        menu_name,
      } = state;

      if (!salesforce_id) {
        return console.log("salesforce id required");
      }

      if (!full_name) {
        return console.log("full_name required");
      }

      if (!default_name) {
        return console.log("default_name required");
      }

      if (!menu_name) {
        return console.log("menu_name required");
      }

      if (!category) {
        return console.log("category required");
      }

      await api
        .post("organizations", {
          id: salesforce_id,
          national: "False",
          salesforce_id: salesforce_id,
          affinity_organization_id: "123",
          account_name: account_name,
          full_name: "123",
          colloquial_name: "123",
          colloquial_phrase: "123",
          colloquial_letters: "123",
          acronym_name: "123",
          default_name: default_name,
          category: category,
          menu_name: menu_name,
          motto: "123",
          motto_short: "123",
          motto_long: "123",
          founding_year: "123",
          city: "",
          state: "",
          parents: ["123"],
          licensing: ["123"],
          tags: ["123"],
        })
        .then((res) => {
          history.push({
            pathname: "organizations",
          });
        })
        .catch((err) => {
          console.log(err);
        });

      setState({
        id,
        salesforce_id,
        account_name,
        full_name,
        default_name,
        category,
        menu_name,
        id_Errors: "",
        account_name_Errors: "",
        salesforce_id_Errors: "",
        full_name_Errors: "",
        default_name_Errors: "",
        category_Errors: "",
        menu_name_Errors: "",
      });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="w-full flex justify-center items-center">
      <div className="max-w-7xl py-6 sm:px-6 lg:px-8 flex flex-col justify-center items-center ">
        <div className="">
          <div className="px-4 sm:px-0">
            <div className="text-lg font-medium leading-6 text-gray-900">
              Add Organization
            </div>
            <p className="mt-1 text-sm text-gray-600">
              Please add organization details
            </p>
          </div>
          <div className="w-full mt-8">
            <div className="mt-1 flex">
              <Input
                label="Account Name - Required"
                field="account_name"
                errors={state.account_name_Errors}
                value={state.account_name}
                onChange={handleChange}
              />
            </div>
            <div className="mt-1 flex">
              <Input
                label="Salesforce Id - Required"
                field="salesforce_id"
                errors={state.salesforce_id_Errors}
                value={state.salesforce_id}
                onChange={handleChange}
              />
            </div>
            <div className="mt-1 flex ">
              <Input
                label="Full Name"
                field="full_name"
                errors={state.full_name_Errors}
                value={state.full_name}
                onChange={handleChange}
              />
            </div>
            <div className="mt-1 flex ">
              <Input
                label="Default Name"
                field="default_name"
                errors={state.default_name_Errors}
                value={state.default_name}
                onChange={handleChange}
              />
            </div>
            <div className="mt-1 flex">
              <Input
                label="Category"
                field="category"
                errors={state.category_Errors}
                value={state.category}
                onChange={handleChange}
              />
            </div>
            <div className="mt-1 flex">
              <Input
                label="Campus Category"
                field="menu_name"
                errors={state.menu_name_Errors}
                value={state.menu_name}
                onChange={handleChange}
              />
            </div>
            <div className="px-4 py-3 text-right sm:px-6 mt-8">
              <button
                onClick={() => submit()}
                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Save Organization
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
